const XOR_KEY = 0xabcd

export const selectedOrganisationCodeCryptographer = {
  encrypt: (code: number): string => {
    return (code ^ XOR_KEY).toString(16)
  },
  decrypt: (encrypted: string | null): number | null => {
    if (encrypted) {
      return parseInt(encrypted, 16) ^ XOR_KEY
    }
    return null
  },
}
